class MattressHtmlData {
    constructor(mattresses) {
        this.mattresses = mattresses;
        this.objects= {
            compareOne: null,
            compareTwo: null,
            compareThree: null
        }
    }

    setRow = (key) => {
        let col = ``;
        Object.keys(this.objects).map(objKey => {
            let value = this.objects[objKey].content[key];
            col = col + `
                <div class="col ${this.objects[objKey].title === 'Luxara Platinum Mattress' ? 'platinum' : ''} ${this.objects[objKey].title === 'Luxara Classic Mattress' ? 'classic' : ''}">
                    <div class="bg-light-2 p-4 h-100 text-center">
                        <p class="fs-14 mb-3">${key}</p>
                        <h3 class="fs-20 fw-600 ${(value === 'Yes' || value === 'No') ? 'mb-1' : ''}">
                            ${value === 'Yes' ? "<img src='//luxara.com.au/cdn/shop/t/22/assets/tik.png?v=174395367860488470121758637412' class='tik' style='height: 24px'/>" 
                                : value === 'No' ? "<img src='//luxara.com.au/cdn/shop/t/22/assets/cross.png?v=127061121075728922481758637412' class='cross' style='height: 24px'/>"
                                : value
                            }
                        </h3>
                    </div>
                </div>
            `
        })
        let row = col + `<div class="col-12"><hr></div>`
        return row;
    }
    
    setHtml = (container) => {
        container.empty();
        let contentModel = this.objects[Object.keys(this.objects)[0]].content;
        Object.keys(contentModel).map(key => {
            let row = this.setRow(key);
            container.append(row);
        })
    }
    
    setInitialObject = (fieldElements, attrName)=> {
        let self = this;
        fieldElements.each(function(){
            let key = $(this).attr(attrName);
            let value = self.mattresses[this.value];
            self.objects[key] = value;
        })
    }
    
    setContentOnLoad = (container, fieldElements, attrName)=> {
        this.setInitialObject(fieldElements, attrName);
        this.setHtml(container);
    }

    onChangeSelectField = (container, objToBeChanged, value)=> {
        this.objects[objToBeChanged] = mattresses[value];
        this.setHtml(container);
    }
}

let comparePageContent = new MattressHtmlData(mattresses);

comparePageContent.setContentOnLoad($('#compareData'), $('.selectMattress'), 'name');

$('.selectMattress').on('change', function(e) {
    let objToBeChanged = e.target.name;
    let value = this.value;
    comparePageContent.onChangeSelectField($('#compareData'), objToBeChanged, value);
})